export const adAreaStyle = {
  display: 'grid',
  gridTemplateColumns: 'auto auto auto',
  gridGap: '1.2rem',
  justifyContent: 'center',
  margin: '1rem',
};

export const boardStyle = {
  display: 'flex',
  flexDirection: 'column',
};

export const paginationStyle = {
  display: 'flex',
  justifyContent: 'center',
};

export const boardCardStyle = {
  width: 240,
  height: 330,
};
